import { SpaqFireDb } from './spaq-fire-db.service';
import { Injectable } from '@angular/core';
import { AccessCodeGroupInfo, AccessCodeInfo, OrganizationConfigInfo } from './shared-constants';
import { firstValueFrom, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

const placeHolderData = { organizationCode: null, organizationName: 'Choisir une organisation' };
const placeHolderDataGroups = { groupCode: null, groupDescription: 'Choisir un groupe' };

@Injectable()
export class OrganizationsService {
	public selectedOrganization$ = new BehaviorSubject(placeHolderData);
	public selectedGroup$ = new BehaviorSubject(placeHolderDataGroups);
	public isGroupSelection = true;
	public isOrganizationSelection = true;

	constructor(private db: SpaqFireDb) {}

	get(search: AccessCodeInfo): Observable<AccessCodeGroupInfo> {
		return this.db.organizationGroup$<AccessCodeGroupInfo>(search.organizationCode, search.groupCode);
	}

	changeOrganization($event) {
		this.selectedOrganization$.next($event);
		this.selectedGroup$.next(placeHolderDataGroups);
	}

	disableGroupSelection() {
		this.isGroupSelection = false;
	}

	enableGroupSelection() {
		this.isGroupSelection = true;
	}

	disableOrganizationSelection() {
		this.isOrganizationSelection = false;
	}

	enableOrganizationSelection() {
		this.isOrganizationSelection = false;
	}

	changeGroup($event) {
		this.selectedGroup$.next($event);
	}

	getSelectedOrganizationGroups(placeHolder = false) {
		return this.selectedOrganization$.pipe(
			map((organization: any) => Object.values(organization.groups || [])),
			map(groups => [...(placeHolder ? [placeHolderDataGroups] : []), ...groups])
		);
	}

	getAll(placeHolder = false): Observable<any> {
		return this.db.organizationsSnapshot$().pipe(
			map(org =>
				org.map((x: any) => {
					return { ...(x.payload.val() as object), organizationId: x.key };
				})
			),
			map(org => [...(placeHolder ? [placeHolderData] : []), ...org])
		);
	}

	async addOrganization(form: any) {
		const id = form.organizationCode.toUpperCase();
		if (await firstValueFrom(this.getOrganizationById(id))) {
			return Promise.reject('Cette organisation est déjà présente');
		} else {
			return this.db.setOrganization(id, {
				...form,
				organizationCode: id
			});
		}
	}
	async updateOrganization(form: any) {
		const id = form.organizationCode.toUpperCase();
		if (await firstValueFrom(this.getOrganizationById(id))) {
			return this.db.updateOrganization(id, {
				...form,
				organizationCode: id
			});
		} else {
			return Promise.reject('Cette organisation existe pas');
		}
	}

	getOrganizationById(id: string): Observable<any> {
		return this.db.organization$<any>(id);
	}

	getOrganizationConfig(id: string): Observable<OrganizationConfigInfo> {
		return this.db.organizationConfig$<OrganizationConfigInfo>(id);
	}

	hydrate(): Observable<any> {
		return this.db.organizationsSnapshot$().pipe(
			map(org =>
				org.map(x => {
					return { ...(x.payload.val() as object), organizationId: x.key };
				})
			)
		);
	}

	hydrateOrganizationScope(data: any): Observable<any> {
		return this.db.organizationSnapshot$(data.scope).pipe(
			map(org =>
				[org.payload.val()].map(x => {
					return { ...(x as object), organizationId: data.scope };
				})
			)
		);
	}
}
